import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import {createPopper} from '@popperjs/core'

const Tooltip = ({placement = 'right', offset = [-3, 20], trigger, children}) => {
  const [toggledState, setToggledState] = React.useState(false)
  const popperRef = React.useRef()

  const triggerRef = React.useRef()
  const popupRef = React.useRef()

  const showHandler = React.useCallback(() => {
    setToggledState(true)
  }, [toggledState])

  const hideHandler = React.useCallback(() => {
    setToggledState(false)
  }, [toggledState])

  React.useEffect(() => {
    if (toggledState) {
      if (!popperRef.current) {
        popperRef.current = createPopper(triggerRef.current, popupRef.current, {
          placement,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset,
              },
            },
            {
              name: 'arrow',
              options: {
                element: '[data-popper-arrow]',
              },
            },
            {
              name: 'computeStyles',
              options: {
                gpuAcceleration: false,
              },
            },
          ],
        })
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (popperRef.current) {
        popperRef.current.destroy()
        popperRef.current = null
      }
    }
  }, [toggledState])

  React.useEffect(
    () => () => {
      if (popperRef.current) {
        popperRef.current.destroy()
      }
    },
    []
  )

  const tooltipProps = {
    onMouseEnter: showHandler,
    onMouseLeave: hideHandler,
    onFocus: showHandler,
    onBlur: hideHandler,
    ref: triggerRef,
  }

  return (
    <>
      {trigger(tooltipProps)}

      {toggledState &&
        ReactDOM.createPortal(
          <div className={`${toggledState ? '' : 'is-hidden'} is-overlay`}>
            <div style={{zIndex: 99999}} ref={popupRef} className="r-popper">
              <div data-popper-arrow className="r-arrow" />
              <div className="r-tooltip">
                <div className="r-tooltip-content">{children}</div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  )
}

Tooltip.propTypes = {
  placement: PropTypes.oneOf([
    'top-start',
    'top',
    'top-end',
    'right-end',
    'right',
    'right-start',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start',
  ]),
  offset: PropTypes.array,
}

export default Tooltip
